import React, { useEffect, useState } from "react";
import { StoreService } from "../services/store-service";
import styles from "./ServiceList.module.css";
import { ReactComponent as ArrowLeftIcon } from "../assets/icons/arrowLeft.svg";
import ServiceCard from "./ServiceCard";
import { useTheme } from "../ThemeContext";

interface Service {
  id: number;
  name: string;
  logo: string;
  description: string;
  partners: any[];
}

const ServiceList: React.FC = () => {
  const [services, setServices] = useState<Service[]>([]);
  const { isDarkMode } = useTheme(); // گرفتن تم

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("android")) {
      document.body.classList.add("android");
      document.body.classList.remove("ios");
    } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
      document.body.classList.add("ios");
      document.body.classList.remove("android");
    } else {
      document.body.classList.remove("android");
      document.body.classList.remove("ios");
    }
  }, []);
  


  useEffect(() => {
    const storedServices = StoreService.GetData("categories");

    if (storedServices) {
      const updatedServices = storedServices.map((service: Service) => {
        const [name, ext] = service.logo.split(".");
        const finalLogo = isDarkMode
          ? `/assets/icons/categories/${name}-dark.${ext}`
          : `/assets/icons/categories/${name}.${ext}`;

        return {
          ...service,
          logo: finalLogo, // مسیر لوگو درست شده
        };
      });

      setServices(updatedServices);
    }
  }, [isDarkMode]); // حتماً وابسته به تغییر تم باشه

  return (
    <div className={styles.serviceListPage}>
      <div className={styles.serviceListHeader}>
        <h6 className="m-0 fw-bold">سرویس‌ها</h6>
        <button
          className={styles.backButton}
          onClick={() => window.history.back()}
        >
          <ArrowLeftIcon className={styles.arrowIcon} />
        </button>
      </div>

      <div className={styles.serviceListContent}>
        {services.map((service: Service) => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </div>
    </div>
  );
};

export default ServiceList;
